export const investorProductScenario = {
  id: 'investor',
  label: 'Investor',
  company: 'Acoord Investor Brief',
  owner: 'Investor Relations',
  role: 'Venture · Strategic · Operator review',
  hook: 'Turn investor diligence into an inspectable product, evidence, and human-authority review.',
  intent: 'Review how Acoord understands intent, grounds evidence, coordinates agents, preserves approval, and records enterprise decisions.',
  trigger: 'An investor opens the qualification brief and asks how the operating system works end to end.',
  checkpoint: 'The investor selects which product, trust, and commercial claims require deeper diligence.',
  outcome: 'Eleven product surfaces reviewed with evidence questions organized for the next conversation.',
  metric: '11 surfaces explained',
  teamspace: 'Investor Diligence Room',
  document: 'Acoord Investor Product Brief',
  workflow: 'Investor Diligence Orchestrator',
  channel: 'investor-diligence',
  agents: ['Product Architecture', 'Evidence Analyst', 'Trust Reviewer', 'Brief Writer'],
  people: ['Investor', 'Acoord Product', 'Enterprise Operator'],
  knowledge: ['Product Architecture Brief', 'Human Authority Model', 'Enterprise Security Controls', 'Modeled Workflow Evidence', 'Operating System Roadmap'],
  graphNodes: ['Investor Thesis', 'Enterprise Need', 'Ahi Control Plane', 'Human Checkpoint', 'Decision Record', 'Acoord Product'],
  tasks: ['Understand the thesis', 'Inspect product evidence', 'Review human authority', 'Map enterprise fit', 'Prepare diligence questions'],
  codeFile: 'verify_investor_claims.py',
  codeTask: 'Validate modeled product claims and evidence coverage inside an isolated diligence sandbox.',
  browserUrl: 'https://acoord.co/legal/security',
  browserTitle: 'Acoord security and assurance center',
  browserItems: ['Security controls reviewed', 'Human approval boundaries verified'],
  message: '@ahi show the investor how intent becomes grounded, reviewable work. Keep every material claim behind evidence.',
  agentReply: 'The product path is mapped across eleven surfaces. Evidence, authority, and the final decision record remain visible throughout.'
};